import generateContext, { createAction } from '..';

interface ICurrentUserState {
  isProductOverviewSeen: boolean;
  isConsentBannerActive: boolean;
}

const initialState: ICurrentUserState = {
  isProductOverviewSeen: false,
  isConsentBannerActive: false,
};

export interface IUser {
  id: string;
  name: string;
  isCourierPortalEnabled?: boolean;
  logoUrl: string;
  location: {
    lat: number;
    lng: number;
  };
  language: string;
  country: string;
}

enum CurrentUserActionType {
  SetIsProductOverviewSeen = 'SET_IS_PRODUCT_OVERVIEW_SEEN',
  SetIsConsentBannerActive = 'SET_IS_CONSENT_BANNER_ACTIVE',
}

const reducer = (
  state: ICurrentUserState,
  action: { type: CurrentUserActionType; payload?: any }
): ICurrentUserState => {
  switch (action.type) {
    case CurrentUserActionType.SetIsProductOverviewSeen:
      return {
        ...state,
        isProductOverviewSeen: action.payload,
      };
    case CurrentUserActionType.SetIsConsentBannerActive:
      return {
        ...state,
        isConsentBannerActive: action.payload,
      };

    default:
      return state;
  }
};

const [CurrentUserCtxProvider, useCurrentUserState, useCurrentUserDispatch] =
  generateContext(reducer, initialState);

const useCurrentUserActions = () => {
  const dispatch = useCurrentUserDispatch();

  const setIsProductOverviewSeen = (value: boolean) => {
    dispatch(
      createAction(CurrentUserActionType.SetIsProductOverviewSeen, value)
    );
  };

  const setIsConsentBannerActive = (value: boolean) => {
    dispatch(
      createAction(CurrentUserActionType.SetIsConsentBannerActive, value)
    );
  };

  return {
    setIsProductOverviewSeen,
    setIsConsentBannerActive,
  };
};

export { CurrentUserCtxProvider, useCurrentUserState, useCurrentUserActions };
